// libraries.
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

// slices.
import { apiDocumentReview } from "../apiSlices";

// interfaces.
import { ModelError } from "../interfaces/interfaces";

interface DocumentDomainCorrectionParams {
  country: string;
  nid: string;
}

interface DocumentDomainCorrectionResponse {
  success: boolean;
  message?: string;
  data?: unknown;
}

export const documentDomainCorrection = apiDocumentReview.injectEndpoints({
  endpoints: (builder) => ({
    correctDocumentDomain: builder.mutation<
      DocumentDomainCorrectionResponse,
      DocumentDomainCorrectionParams
    >({
      query: (body: DocumentDomainCorrectionParams) => ({
        body,
        method: "POST",
        url: "/document_domain_correction",
      }),
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: "correctDocumentDomain",
        };
        return modelError;
      },
      transformResponse: (response: DocumentDomainCorrectionResponse) => {
        return response;
      },
    }),
  }),
});

export const { useCorrectDocumentDomainMutation } = documentDomainCorrection;
